var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _polygon2, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _polygon3, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle, _polygon4, _circle2, _circle3, _circle4, _polygon5, _polygon6, _polygon7, _polygon8, _path14, _polygon9, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _polygon0, _path23, _polygon1, _path24, _polygon10, _path25;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogistics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 548.3,
    height: 592.13,
    viewBox: "0 0 548.3 592.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 270.13,
    y1: 159.41,
    x2: 831.36,
    y2: -407.54,
    gradientTransform: "matrix(1, 0, 0, -1, -118.66, 420.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 588.8,
    y1: 289.07,
    x2: 627.69,
    y2: 289.07,
    gradientTransform: "matrix(1, 0, 0, -1, -118.66, 420.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1417.73,
    y1: -1640.46,
    x2: -1426.56,
    y2: -1649.36,
    gradientTransform: "matrix(0.61, 0.79, 0.79, -0.61, 2610.8, 414.44)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 239.16,
    y1: 482.64,
    x2: 302.23,
    y2: 500.28,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 258.26,
    y1: 529.76,
    x2: 299.56,
    y2: 599.21,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 261.68,
    y1: 133.04,
    x2: 274.56,
    y2: 133.04,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a7fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 275.01,
    y1: 506.95,
    x2: 227.14,
    y2: 532.66,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 283.94,
    y1: 111.83,
    x2: 265.18,
    y2: 107.56,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69b9eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 277.02,
    y1: 62.43,
    x2: 258.26,
    y2: 58.16,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 253.68,
    y1: 257.74,
    x2: 331.41,
    y2: 172.24,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 233.34,
    y1: 214.11,
    x2: 326.62,
    y2: 104.18,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 279.18,
    y1: 623.2,
    x2: 271.46,
    y2: -293.03,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 271.28,
    y1: 623.26,
    x2: 263.56,
    y2: -292.96,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 277.53,
    y1: 334.8,
    x2: 273.02,
    y2: 505.23,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 286.62,
    y1: 173.34,
    x2: 264.27,
    y2: 168.25,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 148.1,
    y1: 186.08,
    x2: 222.09,
    y2: 99.11,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 212.73,
    y1: 180.78,
    x2: 253.38,
    y2: 133,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 144.42,
    y1: 92.32,
    x2: 227.16,
    y2: 6.82,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 192.36,
    y1: 623.93,
    x2: 184.65,
    y2: -292.3,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 164.83,
    y1: 624.16,
    x2: 157.11,
    y2: -292.06,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 190.81,
    y1: 406.56,
    x2: 185.18,
    y2: 605.34,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 161.48,
    y1: 478.34,
    x2: 160.35,
    y2: 646.15,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 133.34,
    y1: 322.49,
    x2: 255.49,
    y2: 236.98,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 118.18,
    y1: 264.01,
    x2: 245.87,
    y2: 159.63,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 186.56,
    y1: 623.98,
    x2: 178.84,
    y2: -292.25,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 177.62,
    y1: 624.05,
    x2: 169.91,
    y2: -292.17,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 184.23,
    y1: 280.68,
    x2: 186.49,
    y2: 476.65,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 175.59,
    y1: 338.99,
    x2: 173.34,
    y2: 571.37,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 196.47,
    y1: 376.29,
    x2: 281.22,
    y2: 372.35,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 600)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 264.72,
    y1: 414.22,
    x2: 205.78,
    y2: 507.7,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 377.21,
    y1: 190.58,
    x2: 471.59,
    y2: 46.23,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 287.7,
    y1: 30.54,
    x2: 444.2,
    y2: 30.54,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 411.75,
    y1: 622.08,
    x2: 404.04,
    y2: -294.14,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 367.27,
    y1: 622.45,
    x2: 359.55,
    y2: -293.77,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 408.01,
    y1: 364.54,
    x2: 413.64,
    y2: 833.06,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 362.5,
    y1: 447.13,
    x2: 368.13,
    y2: 915.65,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 379.4,
    y1: 74.52,
    x2: 400.94,
    y2: 74.52,
    gradientTransform: "matrix(1, 0, 0, -1, -118.66, 420.26)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 348.11,
    y1: 191.74,
    x2: 399.29,
    y2: 191.74,
    gradientTransform: "matrix(1, 0, 0, -1, -118.66, 420.26)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 379.76,
    y1: -43.68,
    x2: 654.16,
    y2: -43.68,
    gradientTransform: "matrix(1, 0, 0, -1, -118.66, 420.26)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 382.46,
    y1: -38.68,
    x2: 654.16,
    y2: -38.68,
    gradientTransform: "matrix(1, 0, 0, -1, -118.66, 420.26)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 298.3,
    y1: -60.71,
    x2: 320,
    y2: -60.71,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 304.14,
    y1: 735.91,
    x2: 304.99,
    y2: 653.98,
    gradientTransform: "translate(918.42 88.77) rotate(80.78)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 486.92,
    y1: 737.82,
    x2: 487.76,
    y2: 655.89,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 294.89,
    y1: -55.76,
    x2: 316.5,
    y2: -63.26,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 472.5,
    y1: -60.71,
    x2: 494.2,
    y2: -60.71,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 365.35,
    y1: 174.13,
    x2: 305.75,
    y2: 114.05,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 327.72,
    y1: 64.28,
    x2: 262.38,
    y2: -1.6,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 547.84,
    y1: 146.97,
    x2: 538.12,
    y2: 137.18,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 509.6,
    y1: 488.74,
    x2: 503.13,
    y2: 426.79,
    gradientTransform: "translate(0 -173.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 567.72,
    y1: 482.66,
    x2: 561.24,
    y2: 420.72,
    gradientTransform: "translate(0 -173.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 458.29,
    y1: 294.31,
    x2: 296.11,
    y2: 315.15,
    gradientTransform: "translate(0 -173.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 408.69,
    y1: 308.69,
    x2: 335.11,
    y2: 322.58,
    gradientTransform: "translate(0 -173.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 925.34,
    y1: 450.8,
    x2: 981.82,
    y2: 450.8,
    gradientTransform: "matrix(0.99, -0.12, -0.12, -0.99, -428.36, 605.76)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 489.74,
    y1: 316.84,
    x2: 489.04,
    y2: 346.97,
    gradientTransform: "translate(0 -173.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 477.06,
    y1: 308.22,
    x2: 442.99,
    y2: 304.14,
    gradientTransform: "translate(-60.01 -175.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 499.96,
    y1: 297.1,
    x2: 506.39,
    y2: 286.17,
    gradientTransform: "matrix(1, 0, 0, -1, -60.01, 422.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#65d5f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5db7d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#51859f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#404059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 626.89,
    y1: 286.84,
    x2: 595.24,
    y2: 245.34,
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logistics") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M268,585.54c-117.3-17-188.5-100.1-204.5-199-9.9-60.8,1.1-127.5,34.9-188.6C187.3,37.34,412,33.64,412,33.64c129.3-6.4,103.8,211.9,96.3,259-4,24.9,21.2,58.2,47.3,93.9,23.1,31.6,47.1,65.2,52.1,96.5C618.5,549.54,457.3,613,268,585.54Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#2c7be5",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268,586.94c-117.3-17-188.5-100.1-204.5-199H555.7c23.2,31.6,47.1,65.2,52.1,96.5C618.5,550.94,457.3,614.44,268,586.94Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#2c7be5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268,586.94c-117.3-17-188.5-100.1-204.5-199H555.7c23.2,31.6,47.1,65.2,52.1,96.5C618.5,550.94,457.3,614.44,268,586.94Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.4,501.84c-5.9-.1-13-.9-15.7-6.2-1.3-2.6-1.2-5.7-1.6-8.7-4-26.3-50-25.1-57.6-50.6-.6-2.2-.9-4.9.7-6.6,1.4-1.5,3.6-1.8,5.6-1.9l66.9-4.7c2.7-9.9-7.9-18.3-17.6-21.4-43.7-14-93.3,14.8-136.3-1.5-2.3-.9-4.7-2-5.8-4.2-3.1-6.3,6.8-10.7,13.9-10.8l169.2-2.7c3.6-.1,7.2-.1,10.6,1,5.2,1.7,9.2,5.9,13,9.9,16,17.1,32.6,34.5,53.6,45,38.5,19.2,84.5,12.1,126.8,20.2,12.2,2.4,27.2,10.8,24.2,22.8-9.6,37.8-80.9,23.6-106.5,23.1Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#1d2741",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M459.2,83.54l.1,32.9,12.9,33.8,10.5-5a5.79,5.79,0,0,1,7.5,2.3l2.8,4.9a7.52,7.52,0,0,1-2.7,10.3h0l-.3.2c-7.6,4-23,13.6-25.9,13.6-4.4,0-17.2-19.8-17.2-19.8Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#2c7be5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M486.8,144.94s-4.7,3.7-2.5,7.7,9.7,4.2,9.7,4.2S500.1,145.94,486.8,144.94Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#2c7be5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M490.1,122.54a41.88,41.88,0,0,1,6.9,1.3l10.4,2.5a2.67,2.67,0,0,1,1.4.7c.6.8-.3,2-1.2,2.3-3,1.2-6.8-1-9.5.8-1.5,1-2,3-3.2,4.3-1.5,1.8-4,2.6-6.4,2.8a55.08,55.08,0,0,0-7.1.7c-3.5.8-7.2,3.1-10.4,1.3a2.7,2.7,0,0,1-.8-.7c-.4-.7.1-1.6.5-2.4a12.3,12.3,0,0,0,1.4-6.8c-.1-3.3-.2-3,3.1-4.2C480,123.54,485,122.14,490.1,122.54Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient-2)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "434.59 291.86 434.29 298.76 446.39 298.66 447.19 289.16 434.59 291.86",
    fill: "url(#linear-gradient-3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M494.3,300.14l12.1-.1,3.7,4.8s16.1,5.8,19.1,13.7,2.4,12,2.4,12l-42.4-13.9Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#2c7be5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M406,184.64s85.1.6,92.1,5.5c19.4,13.5,13.4,100.9,13.4,100.9l-17.3,5-14-74.2Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#25233a"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 171.79,
    y: 284.56,
    width: 71.5,
    height: 49.6,
    fill: "#2c7be5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 176.39,
    y: 286.06,
    width: 24.8,
    height: 47.8,
    fill: "url(#linear-gradient-4)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 166.89,
    y: 334.16,
    width: 71.5,
    height: 55.2,
    fill: "#2c7be5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 166.89,
    y: 334.16,
    width: 71.5,
    height: 55.2,
    fill: "url(#linear-gradient-5)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 201.69,
    y: 284.56,
    width: 12.9,
    height: 10.1,
    fill: "url(#linear-gradient-6)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 194.69,
    y: 333.96,
    width: 12.9,
    height: 10.1,
    fill: "url(#linear-gradient-7)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 294.66,
    width: 1,
    height: 39.3,
    fill: "url(#linear-gradient-8)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 201.19,
    y: 344.06,
    width: 1,
    height: 39.3,
    fill: "url(#linear-gradient-9)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 172.79,
    y: 159.26,
    width: 85.2,
    height: 59.1,
    fill: "#2c7be5"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 172.79,
    y: 159.26,
    width: 85.2,
    height: 59.1,
    fill: "url(#linear-gradient-10)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 166.89,
    y: 218.26,
    width: 85.2,
    height: 65.8,
    fill: "#2c7be5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 166.89,
    y: 218.26,
    width: 85.2,
    height: 65.8,
    fill: "url(#linear-gradient-11)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 208.39,
    y: 159.26,
    width: 15.4,
    height: 12,
    fill: "url(#linear-gradient-12)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 199.99,
    y: 218.06,
    width: 15.4,
    height: 12,
    fill: "url(#linear-gradient-13)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 215.99,
    y: 171.26,
    width: 1.2,
    height: 46.8,
    fill: "url(#linear-gradient-14)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 207.79,
    y: 230.06,
    width: 1.2,
    height: 46.8,
    fill: "url(#linear-gradient-15)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 79.29,
    y: 244.06,
    width: 97.2,
    height: 67.4,
    fill: "#2c7be5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "176.39 284.06 176.39 311.36 79.29 311.36 79.29 244.06 166.89 244.06 166.89 284.06 176.39 284.06",
    fill: "url(#linear-gradient-16)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 166.89,
    y: 244.06,
    width: 9.5,
    height: 40.1,
    fill: "url(#linear-gradient-17)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 53.79,
    y: 311.36,
    width: 97.2,
    height: 75.1,
    fill: "#2c7be5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 53.79,
    y: 311.36,
    width: 97.2,
    height: 75.1,
    fill: "url(#linear-gradient-18)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 119.79,
    y: 244.06,
    width: 17.5,
    height: 13.7,
    fill: "url(#linear-gradient-19)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 91.69,
    y: 311.16,
    width: 17.5,
    height: 13.7,
    fill: "url(#linear-gradient-20)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 128.59,
    y: 257.76,
    width: 1.4,
    height: 53.4,
    fill: "url(#linear-gradient-21)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 324.86,
    width: 1.3,
    height: 53.4,
    fill: "url(#linear-gradient-22)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 74.59,
    y: 101.36,
    width: 97.2,
    height: 67.4,
    fill: "#2c7be5"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 74.59,
    y: 101.36,
    width: 97.2,
    height: 67.4,
    fill: "url(#linear-gradient-23)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 67.89,
    y: 168.76,
    width: 97.2,
    height: 75.1,
    fill: "#2c7be5"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 67.89,
    y: 168.76,
    width: 97.2,
    height: 75.1,
    fill: "url(#linear-gradient-24)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 115.19,
    y: 101.36,
    width: 17.5,
    height: 13.7,
    fill: "url(#linear-gradient-25)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 105.69,
    y: 168.46,
    width: 17.5,
    height: 13.7,
    fill: "url(#linear-gradient-26)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 123.99,
    y: 115.06,
    width: 1.3,
    height: 53.4,
    fill: "url(#linear-gradient-27)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 114.49,
    y: 182.16,
    width: 1.3,
    height: 53.4,
    fill: "url(#linear-gradient-28)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.1,204.94v40.2s-14.6-18.7-14-28.8S225.1,204.94,225.1,204.94Z",
    transform: "translate(-60.01 -1.38)",
    opacity: 0.46,
    fill: "url(#linear-gradient-29)",
    style: {
      isolation: "isolate"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.69 258.76 226.99 284.06 166.89 284.06 166.89 218.26 172.79 218.26 172.79 210.36 181.69 218.26 207.79 241.16 208.89 242.26 227.69 258.76",
    fill: "url(#linear-gradient-30)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 268.59,
    y: 223.16,
    width: 156.5,
    height: 108.5,
    fill: "#2c7be5"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 268.59,
    y: 223.16,
    width: 156.5,
    height: 108.5,
    fill: "url(#linear-gradient-31)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 227.69,
    y: 331.66,
    width: 156.5,
    height: 120.9,
    fill: "#2c7be5"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 227.69,
    y: 331.66,
    width: 156.5,
    height: 120.9,
    fill: "url(#linear-gradient-32)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 333.99,
    y: 223.16,
    width: 28.2,
    height: 22.1,
    fill: "url(#linear-gradient-33)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 288.59,
    y: 331.16,
    width: 28.2,
    height: 22.1,
    fill: "url(#linear-gradient-34)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 348.09,
    y: 245.16,
    width: 2.2,
    height: 86,
    fill: "url(#linear-gradient-35)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 302.89,
    y: 353.26,
    width: 2.2,
    height: 86,
    fill: "url(#linear-gradient-36)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M282.3,453.94H260.8V248.24a10.73,10.73,0,0,1,10.8-10.7h0a10.86,10.86,0,0,1,10.8,10.7v205.7Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#2c7be5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.2,255.74h0a11.29,11.29,0,0,1-15.8-2l-28.6-36.6a11.29,11.29,0,0,1,2-15.8h0a11.27,11.27,0,0,1,15.8,1.9h0l28.6,36.6a11.24,11.24,0,0,1-2,15.9Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#2c7be5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M535.5,463.94h0a10,10,0,0,1-10,10H281.2a20.08,20.08,0,0,1-20.1-20H525.4a10,10,0,0,1,10.1,10Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#2c7be5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M535.5,463.94H281.2a20.07,20.07,0,0,1-17.4-10H525.4a10.05,10.05,0,0,1,10.1,10Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#2c7be5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M282.3,453.94H260.8V248.24a10.73,10.73,0,0,1,10.8-10.7h0a10.86,10.86,0,0,1,10.8,10.7v205.7Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient-37)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M276.2,255.74h0a11.29,11.29,0,0,1-15.8-2l-28.6-36.6a11.29,11.29,0,0,1,2-15.8h0a11.27,11.27,0,0,1,15.8,1.9h0l28.6,36.6a11.24,11.24,0,0,1-2,15.9Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient-38)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M535.5,463.94h0a10,10,0,0,1-10,10H281.2a20.08,20.08,0,0,1-20.1-20H525.4a10,10,0,0,1,10.1,10Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient-39)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M535.5,463.94H281.2a20.07,20.07,0,0,1-17.4-10H525.4a10.05,10.05,0,0,1,10.1,10Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient-40)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 304.8,
    cy: 497.16,
    r: 16.6,
    transform: "translate(-322.28 359.76) rotate(-45)",
    fill: "#2c7be5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 244.89,
    cy: 496.26,
    r: 5,
    fill: "#1d2741",
    opacity: 0.57,
    style: {
      isolation: "isolate"
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "249.09 494.16 238.29 494.16 238.29 472.56 259.99 472.56 249.09 494.16",
    fill: "url(#linear-gradient-41)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.59,
    cy: 495.76,
    r: 16.6,
    fill: "#2c7be5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.8,
    cy: 497.14,
    r: 16.6,
    transform: "translate(-294.75 716.99) rotate(-80.78)",
    fill: "url(#linear-gradient-42)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.59,
    cy: 495.76,
    r: 16.6,
    fill: "url(#linear-gradient-43)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M482.5,497.64a5,5,0,1,0,5-5A5,5,0,0,0,482.5,497.64Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#1d2741",
    opacity: 0.57,
    style: {
      isolation: "isolate"
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "423.29 494.16 434.19 494.16 434.19 472.56 412.49 472.56 423.29 494.16",
    fill: "#2c7be5"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "249.09 494.16 238.29 494.16 238.29 472.56 259.99 472.56 249.09 494.16",
    fill: "#2c7be5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "249.09 494.16 238.29 494.16 238.29 472.56 259.99 472.56 249.09 494.16",
    fill: "url(#linear-gradient-44)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "423.29 494.16 434.19 494.16 434.19 472.56 412.49 472.56 423.29 494.16",
    fill: "url(#linear-gradient-45)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 268.59,
    y: 225.86,
    width: 13.9,
    height: 105.4,
    opacity: 0.2,
    fill: "url(#linear-gradient-46)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.09,
    y: 332.86,
    width: 13.9,
    height: 116.9,
    opacity: 0.2,
    fill: "url(#linear-gradient-47)",
    style: {
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M389.7,183.54S384.4,215,406.9,222s78.2,2.5,78.2,2.5l51.2,60.6L549,268l-46.2-63.4a51,51,0,0,0-33.5-15.9Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#3f3d56"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "476.39 283.76 481.69 288.16 488.99 278.56 484.69 272.56 476.39 283.76",
    fill: "url(#linear-gradient-48)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M541.7,289.54l7.3-9.6h6s14.4-9.2,22.6-6.7,11,5.5,11,5.5l-37,25Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#2c7be5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M494.3,300.14l12.1-.1,3.7,4.8s16.1,5.8,19.1,13.7,2.4,12,2.4,12l-42.4-13.9Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient-49)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M541.7,289.54l7.3-9.6h6s14.4-9.2,22.6-6.7,11,5.5,11,5.5l-37,25Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient-50)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M445.9,185.44H389.5l-.6-.3c-1.8-1-6.4-4.8-5.9-15,.4-7.4,7-34.5,12.4-55.7,3.8-15.1,7.1-27.3,7.1-27.3s7-18.4,18.7-23.2c4.4-1.8,10-4.8,16.1-3.7,10.1,2,20.5,11.1,22,23.4C460.5,93.94,445.9,185.44,445.9,185.44Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#2c7be5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M445.9,185.44H389.5l-.6-.3c-1.8-1-6.4-4.8-5.9-15,.4-7.4,7-34.5,12.4-55.7,3.8-15.1,7.1-27.3,7.1-27.3s7-18.4,18.7-23.2c4.4-1.8,10-4.8,16.1-3.7,10.1,2,20.5,11.1,22,23.4C460.5,93.94,445.9,185.44,445.9,185.44Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient-51)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M409.2,140s-12.8,33.8-3.2,44.6l-17.1.5c-1.8-1-6.4-4.8-5.9-15,.4-7.4,7-34.5,12.4-55.7L418,83.54Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient-52)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M437.2,60.14l6-16.5s7-26.5,23.1-27.9,29.6,10.3,22.8,28.9-10.2,21.5-16.8,22.7-12.8-1.9-12.8-1.9l-5.8,8.8C453.8,74.24,451.9,79.34,437.2,60.14Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient-53)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M408.8,79.24s-27.4,39.6-25.9,49.9c1.8,12.1,53.6,14,74.8,14.6a12.17,12.17,0,0,0,12.2-8.8v-.1a12.34,12.34,0,0,0-8.3-15.3h0a11.63,11.63,0,0,0-1.8-.4l-35.5-4.8L441,82.54c4.3-13.5-11.7-24.5-22.7-15.6A40.64,40.64,0,0,0,408.8,79.24Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#2c7be5"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "412.99 123.96 408.59 123.46 405.59 139.86 410.49 139.86 412.99 123.96",
    fill: "#2c7be5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M486.8,144.94s-4.7,3.7-2.5,7.7,9.7,4.2,9.7,4.2S500.1,145.94,486.8,144.94Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient-54)"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "412.99 123.96 408.59 123.46 405.59 139.86 410.49 139.86 412.99 123.96",
    fill: "url(#linear-gradient-55)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M457.9,39.44c-1.4-.6-.2-3-1.1-4.2s-2.5-.5-3.5.4a7.53,7.53,0,0,0-2.1,7.4,5.69,5.69,0,0,1,.4,2.6c-.5,1.8-2.9,2-4.7,1.6s-3.8-1.2-5.3-.2c-1.3-2.2-.4-5,.6-7.3a76.66,76.66,0,0,1,6.4-12,6.6,6.6,0,0,0,1.2-2.7c.2-1.5-.7-2.8-1.2-4.1-2.6-6.3,1-14,7-17.3s13.5-2.7,19.7,0c2.3,1,4.5,2.3,6.9,2.8,3.6.7,7.3-.3,11-.3a18.11,18.11,0,0,1,14.4,8,18.19,18.19,0,0,1,1.5,16.5c-1.3,3.1-4.5,6.2-7.6,5.1-1.3-.4-2.3-1.5-3.5-2.2s-3-.8-3.8.3a5.55,5.55,0,0,1-.6.8c-1.1.8-2-1.1-2.6-2.2-1.4-2.7-5.2-2.6-8.2-2.5a42.57,42.57,0,0,1-8.7-.7c-2.1-.4-4.9-1.8-7-1.2C464.5,28.44,458.2,39.54,457.9,39.44Z",
    transform: "translate(-60.01 -1.38)",
    fill: "#3f3d56"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "472.99 111.06 475.59 114.16 416.39 156.86 414.09 153.56 472.99 111.06",
    fill: "url(#linear-gradient-56)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M486.8,150.84s1,3.3,6.2,1.6,14.5-7.2,15.3-8.6,8.8-9.7,8.3-14.4Z",
    transform: "translate(-60.01 -1.38)",
    fill: "url(#linear-gradient-57)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/logistics.8b47cdb7723a0b1b4253f2e972202d0a.svg";
export { ForwardRef as ReactComponent };